import { FiUser, FiMail, FiPhone } from "react-icons/fi";
import { cn } from "utils/helpers";

interface RfxLeadInfoBoxProps {
	email: string;
	fullName: string;
	marginBottom?: "2" | "4";
	marginTop?: "2" | "4";
	phoneNumber?: string;
}

export const RfxLeadInfoBox: React.FC<RfxLeadInfoBoxProps> = ({
	fullName,
	marginBottom,
	marginTop,
	email,
	phoneNumber,
}) => {
	return (
		<div
			className={cn("rounded-lg border border-gray-200 bg-gray-50 px-4 py-3"
				, marginBottom && `mb-${marginBottom}`
				, marginTop && `mt-${marginTop}`
			)}
			data-testid="rfx-lead-info-box"
		>
			<p className="mb-2 text-xs font-medium uppercase tracking-wider text-gray-400">
				RFx Lead
			</p>
			<div className="flex flex-wrap items-center gap-x-4 gap-y-1.5">
				<span className="inline-flex items-center gap-1.5 text-sm text-gray-900">
					<FiUser size={14} className="text-gray-400" aria-hidden="true" />
					{fullName}
				</span>
				<a
					href={`mailto:${email}`}
					className="inline-flex items-center gap-1.5 text-sm text-[#0031DD] hover:underline"
				>
					<FiMail size={14} aria-hidden="true" />
					{email}
				</a>
				{phoneNumber && (
					<span className="inline-flex items-center gap-1.5 text-sm text-gray-600">
						<FiPhone size={14} className="text-gray-400" aria-hidden="true" />
						{phoneNumber}
					</span>
				)}
			</div>
		</div>
	);
};
